var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuildings = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.109 9.23v12.082H2.89v-9.708h8.044v8.708h2.13V9.229h8.044Zm-1 1h-6.044v10.082h6.043V10.229ZM9.935 12.603H3.89v7.709h6.044v-7.709Zm-2.13 4.542v1H6.021v-1h1.782Zm10.173-2.375v1h-1.782v-1h1.782Zm-10.174 0v1H6.022v-1h1.782Zm10.174-2.375v1h-1.782v-1h1.782Zm-.782-9.5v4.958h-1V3.896H7.804v6.333h-1V2.896h10.392Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuildings);
export default ForwardRef;